<ng-container *ngIf="preselectedWidgets$ | async as preselectedWidgets">
  <ng-container *ngIf="groupedWidgets$ | async as groupedWidgets">
    <div class="widget-selection-header">
      <markant-button
        class="back-button"
        colorScheme="secondary"
        variant="clear"
        [routerLink]="['/']"
      >
        <markant-icon icon="m_chevron-left" slot="icon-leading"></markant-icon>
        {{ 'dashboard.selection.back' | transloco }}
      </markant-button>
      <markant-button (click)="saveSelected(preselectedWidgets)">
        <markant-icon slot="icon-leading" icon="m_checkmark"></markant-icon>
        {{ 'dashboard.selection.saveSelected' | transloco }}
      </markant-button>
    </div>
    <h2 class="headline">{{ 'dashboard.selection.header' | transloco }}</h2>
    <markant-select
      class="cartridge-filter"
      data-cy-id="cartridgeFilter"
      [value]="filteredWidgetGroupId"
      [label]="'dashboard.selection.filter.header' | transloco"
      [options]="widgetGroupOptions"
      (valueChange)="filterWidgetGroup($event)"
    >
    </markant-select>
    <ng-container
      *ngFor="let widgetGroup of groupedWidgets; let widgetGroupIndex = index"
    >
      <div
        *ngIf="
          filteredWidgetGroupId === 'all' ||
          filteredWidgetGroupId === widgetGroup.groupId
        "
        class="widget-group"
        [attr.id]="widgetGroup.groupId"
        [attr.data-cy-id]="'cartridgeSection' + widgetGroupIndex"
      >
        <h4 class="widget-group-headline">{{ widgetGroup.groupName }}</h4>
        <div class="widget-list" *ngIf="widgetGroup.widgets as widgets">
          <div
            *ngFor="let widget of widgets; let widgetIndex = index"
            class="widget"
            [attr.data-cy-id]="
              'cartridgeSection' + widgetGroupIndex + 'Widget' + widgetIndex
            "
            [ngClass]="['size-' + widget.size]"
            [class.is-preselected]="
              preselectedWidgets
                | getSelectedWidgetClass: widget.id : widgetGroup.variantId
            "
            [class.is-selected]="
              selectedWidgets
                | getSelectedWidgetClass: widget.id : widgetGroup.variantId
            "
            (click)="
              selectWidget(widget, preselectedWidgets, widgetGroup.variantId)
            "
          >
            <span class="markant-h4 widget-name">
              {{ widget.displayName | transloco }}
            </span>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
